function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 0C16.119 0 0 16.119 0 36C0 55.881 16.119 72 36 72C55.881 72 72 55.881 72 36C72 16.119 55.881 0 36 0ZM49.791 53.862L36.018 40.212L22.353 54L18.138 49.785L31.779 36.009L18 22.353L22.215 18.138L35.979 31.767L49.614 18L53.862 22.209L40.224 35.97L54 49.614L49.791 53.862Z",
  fill: "#EF4444"
});

function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.a156165401d263167228c779fd79eed0.svg";
export { ForwardRef as ReactComponent };